import React, { useEffect, useState, useRef } from 'react';

// Custom hook to get navbar height
const useNavbarHeight = () => {
  const [navbarHeight, setNavbarHeight] = useState(0);

  useEffect(() => {
    const navbar = document.querySelector('nav');
    if (navbar) {
      const updateHeight = () => {
        const height = navbar.getBoundingClientRect().height;
        setNavbarHeight(height);
      };

      // Initial measurement
      updateHeight();

      // Update on resize
      window.addEventListener('resize', updateHeight);
      return () => window.removeEventListener('resize', updateHeight);
    }
  }, []);

  return navbarHeight;
};

// Component that provides available height to children
const DynamicHeight = ({ 
  children, 
  className = '',
  subtractHeight = 0 // Additional height to subtract (e.g., for padding)
}) => {
  const navbarHeight = useNavbarHeight();
  const [availableHeight, setAvailableHeight] = useState(0);
  const componentRef = useRef(null);

  useEffect(() => {
    const calculateHeight = () => {
      const windowHeight = window.innerHeight;
      const totalSubtraction = navbarHeight + subtractHeight;
      setAvailableHeight(windowHeight - totalSubtraction);
    };

    calculateHeight();
    window.addEventListener('resize', calculateHeight);
    
    return () => window.removeEventListener('resize', calculateHeight);
  }, [navbarHeight, subtractHeight]);

  return (
    <div 
      ref={componentRef}
      className={className}
      style={{ height: `${availableHeight}px` }}
    >
      {children}
    </div>
  );
};

export { DynamicHeight, useNavbarHeight };
